const CONSTANTS = {
  modalCommunityConfig: "__event_modalCommunityEdit",
  modalGroupConfig: "__event_modalGroupEdit",
};

const communityEvents = {
  triggerModal: {
    configCommunity(e) {
      triggerEvent(CONSTANTS.modalCommunityConfig, e);
    },
    configGroup(e) {
      triggerEvent(CONSTANTS.modalGroupConfig, e);
    },
  },
  addListener: {
    configCommunity(handler) {
      return listenEvent(CONSTANTS.modalCommunityConfig, handler);
    },
    configGroup(handler) {
      return listenEvent(CONSTANTS.modalGroupConfig, handler);
    },
  },
};

function triggerEvent(eventName, payload) {
  const event = new CustomEvent(eventName, { detail: payload });
  window.dispatchEvent(event);
}

function listenEvent(eventName, handler) {
  function eventListener(e) {
    handler(e.detail);
  }
  window.addEventListener(eventName, eventListener);

  return () => window.removeEventListener(eventName, eventListener);
}

export default communityEvents;
